module.exports = __webpack_public_path__ + "img/indicator3b_gray_v2.25b77ce3.svg";